import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Urls } from '@core/config/urls';
import { OldLegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class FileManagementService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/file-manager/storage/documents';
	}

	private dom: DomSanitizer = inject(DomSanitizer);

	public getImageUrl(imageId: string): Observable<any> {
		const requestOptions = {
			params: {
				id: imageId,
			},
			responseType: 'blob',
		};

		return this._restClientService.get(`${this.apiUrl}/download`, requestOptions).pipe(
			map((result) => {
				const url = URL.createObjectURL(result);
				return this.dom.bypassSecurityTrustUrl(url);
			})
		);
	}

	public getFile(id): Observable<any> {
		const requestOptions = {
			params: {
				id,
			},
			responseType: 'blob',
		};

		return this._restClientService.get(`${this.apiUrl}/download`, requestOptions);
	}

	download(id: string) {
		return this._restClientService.get(this.apiUrl + '/download' + `?id=${id}`, {
			responseType: 'blob',
		});
	}
}
